import { memo } from 'react';
import type { FC, ReactNode } from 'react';

import resets from '../../_resets.module.css';
import classes from './CSLOGO_ColoredTrueTextTrueHori.module.css';
import { Layer3Icon } from './Layer3Icon';

interface Props {
  className?: string;
  classes?: {
    layer3?: string;
    root?: string;
  };
  swap?: {
    layer3?: ReactNode;
  };
}
/* @figmaId 1:1288 */
export const CSLOGO_ColoredTrueTextTrueHori: FC<Props> = memo(function CSLOGO_ColoredTrueTextTrueHori(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`}>
      <div className={`${props.classes?.layer3 || ''} ${classes.layer3}`}>
        {props.swap?.layer3 || <Layer3Icon className={classes.icon} />}
      </div>
    </div>
  );
});
